"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var BonusTemplateCurrencyConfigEditor = /** @class */ (function (_super) {
    __extends(BonusTemplateCurrencyConfigEditor, _super);
    function BonusTemplateCurrencyConfigEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTemplateCurrencyConfigEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    description: _item.description,
                    is_default: _item.is_default
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Настройки шаблона бонуса валюты", "Редактирование шаблона бонуса валюты"]);
                });
            }
        }
        else {
            this.setState({
                app_currency_id: 0,
                app_currency_title: "",
                description: "",
                is_default: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Настройки шаблона бонуса валюты", "Добавление шаблона бонуса валюты"]);
            });
        }
        this.doReSetRules();
    };
    BonusTemplateCurrencyConfigEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false }
        });
    };
    BonusTemplateCurrencyConfigEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
            return false;
        }
        return true;
    };
    BonusTemplateCurrencyConfigEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_currency_id: this.state.app_currency_id,
                description: this.state.description,
                is_default: this.state.is_default
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон бонуса валюты изменен!");
            });
        }
    };
    BonusTemplateCurrencyConfigEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_currency_id: this.state.app_currency_id,
                bonus_template_id: this.props.rootRecord.key,
                description: this.state.description,
                is_default: this.state.is_default
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон бонуса валюты добавлен!");
            });
        }
    };
    BonusTemplateCurrencyConfigEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTemplateCurrencyConfigEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить шаблон валюты бонуса";
        }
        else {
            return "Изменить шаблон валюты бонуса";
        }
    };
    BonusTemplateCurrencyConfigEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта шаблона бонуса", placeholder: "Выберите валюту шаблона бонуса" }, value: {
                    key: this.state.app_currency_id,
                    value: this.state.app_currency_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Валюта по-умолчанию", value: this.state.is_default, onChecked: function (checked) { _this.setState({ is_default: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BonusTemplateCurrencyConfigEditor;
}(React.Component));
exports.default = BonusTemplateCurrencyConfigEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/currency_config/BonusTemplateCurrencyConfigEditor.tsx
// module id = 1916
// module chunks = 0